import React from 'react'
import { Route, Routes } from 'react-router'
import { ActiveUIProvider } from '@active/react-ui'
import { config } from '../shared/utils/poperConfig';
import LocaleProvider from '../shared/components/LocaleProvider'
import { adjustLocale, getUrlParams } from '../shared/utils/commonUtils'
import routeConfigs, { defaultRouteConfig } from './routeConf'

// Config FEE Modal. Put into the container
config({
  rootElement() {
    return document.querySelector('.passport-ui-app') || document.body
  },
})

function PassportRoutes() {
  const { locale } = getUrlParams()
  const {
    path: defaultPath,
    pageConfig: { Page: DefaultPage, ...defaultRest },
  } = defaultRouteConfig

  return (
    <LocaleProvider locale={adjustLocale(locale)}>
      <ActiveUIProvider value={{ getRootElement: () => document.querySelector('.passport-ui-app') || document.body }}>
        <section id="passport_content">
          <Routes>
            {
              routeConfigs.map(({ path, pageConfig: { Page, ...rest } }) => (
                <Route
                  key={path}
                  path={path}
                  element={<Page {...rest} isPage />}
                />
              ))
            }
            <Route
              key={defaultPath}
              path={defaultPath}
              element={<DefaultPage {...defaultRest} isPage />}
            />
          </Routes>
        </section>
      </ActiveUIProvider>
    </LocaleProvider>
  )
}

export default PassportRoutes
